export const SubscriptionPlan = {
  FREE: 0,
  PRO: 1,
  // 2 は将来の中間プラン用に予約
  MAX: 3,
  CROWDFUNDING: 9, // クラファン特典（手動付与）
} as const;

/** 有料プランか（Standard以上） */
export const isSubscribed = (plan: number): boolean =>
  plan >= SubscriptionPlan.PRO;

/**
 * 有料登録者か（PULSE PRO 加入者か）
 * @deprecated `isSubscribed` を使ってください。実装は同じ（`plan >= 1`）です。
 * 「PULSE PRO」は STANDARD / MAX を含む**有料サブスク全体のブランド名**であり、
 * 個別の「PROプラン」というティアは存在しません（今後も予定なし）。関数名 `isPro` は
 * 「PROティアか」と誤読される恐れがあるため、「有料登録者か」を素直に表す
 * `isSubscribed` を使うのが適切です。関連箇所を触る際に置き換えてください。
 */
export const isPro = (plan: number): boolean =>
  plan >= SubscriptionPlan.PRO;

/** Max以上か */
export const isMax = (plan: number): boolean =>
  plan >= SubscriptionPlan.MAX;

/** EA機能にアクセスできるか（= Max以上） */
export const isEarlyAccess = (plan: number): boolean =>
  plan >= SubscriptionPlan.MAX;

/**
 * プラン別の上限値の定数。
 * UI側で「STANDARDなら○○字」「MAXなら△△字」のような CTA 表示を出す時に、
 * 個別関数呼びで重複ロジックを書かないように tier 一覧として公開する。
 */
export const POST_LIMITS = { free: 200, standard: 500, max: 1000 } as const;
export const MEMO_LIMITS = { free: 200, standard: 1000, max: 10000 } as const;
/** ライブラリのフォルダ作成数の上限 */
export const FOLDER_COUNT_LIMITS = { free: 3, standard: 20, max: 100 } as const;
/** 1フォルダに入れられるゲーム件数の上限 */
export const FOLDER_ITEM_LIMITS = { free: 10, standard: 100, max: 300 } as const;

/** プラン別のポスト最大文字数 */
export const getPostMaxLength = (plan: number): number => {
  if (plan >= SubscriptionPlan.MAX) return POST_LIMITS.max;
  if (plan >= SubscriptionPlan.PRO) return POST_LIMITS.standard;
  return POST_LIMITS.free;
};

/** プラン別のゲーム非公開メモ最大文字数 */
export const getMemoMaxLength = (plan: number): number => {
  if (plan >= SubscriptionPlan.MAX) return MEMO_LIMITS.max;
  if (plan >= SubscriptionPlan.PRO) return MEMO_LIMITS.standard;
  return MEMO_LIMITS.free;
};

/** プラン別のフォルダ作成数の上限 */
export const getFolderMaxCount = (plan: number): number => {
  if (plan >= SubscriptionPlan.MAX) return FOLDER_COUNT_LIMITS.max;
  if (plan >= SubscriptionPlan.PRO) return FOLDER_COUNT_LIMITS.standard;
  return FOLDER_COUNT_LIMITS.free;
};

/** プラン別の1フォルダあたりのゲーム件数上限 */
export const getFolderItemMaxCount = (plan: number): number => {
  if (plan >= SubscriptionPlan.MAX) return FOLDER_ITEM_LIMITS.max;
  if (plan >= SubscriptionPlan.PRO) return FOLDER_ITEM_LIMITS.standard;
  return FOLDER_ITEM_LIMITS.free;
};
